import FireParticle from "../../../../physics/magic/FireParticle"
import ManaParticle from "../../../ManaParticle"
import NodeCategories from "../../NodeCategories"
import SimpleManaNode, { SimpleManaNodeOptions } from "../../SimpleManaNode"

export type FireNodeOptions = {} & SimpleManaNodeOptions

export default class FireNode extends SimpleManaNode {

	static nodeName = "Fire Node"
	static nodeDesc = "Spawns fire"
	static nodeIcon = '🔥'
	static category = NodeCategories.Element
	static nodeType = 'FireNode'


	constructor({ ...rest }: FireNodeOptions) {
		super({
			...rest,

			cooldown: 0.1,
			cost: 1,
		})
	}

	async act(particle: ManaParticle) {

		const physicsWorld = this.world?.physicsWorld

		if (physicsWorld) {
			const fireParticle = new FireParticle({
				world: physicsWorld,

				x: particle.target.position.x,
				y: particle.target.position.y,

				amp: this.getAmp(particle)
			})

			physicsWorld.add(fireParticle)
			particle.setTarget(fireParticle)

			return true;
		}
		return false
	}

}